import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useKnowledgeStore } from '@getmayday/vue-modules';

export default (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const { modalContentId, silent, source } = to.query;
  const fromModalContentId = from.query.modalContentId;
  const knowledgeStore = useKnowledgeStore();

  if (modalContentId && modalContentId !== '-1' && !silent) {
    const splitId = (modalContentId as string).split('#');
    const contentId = splitId[0];
    const modalHash = splitId[1] || '';
    const hash = modalHash ? `#${modalHash}` : '';
    const isModal = true;

    if (fromModalContentId === modalContentId) {
      if (hash) knowledgeStore.setContentHash({ hash, isModal });
      return next();
    }

    const { modalContent, content } = storeToRefs(knowledgeStore);
    if (modalContent.value.id === modalContentId) return next();

    knowledgeStore.getEntityAncestors({
      id: contentId,
      entityType: 'Content',
      isModal,
      hash,
      source: source as string,
      shouldLog: content.value.id !== modalContentId,
    });
  }
  next();
};
